import { PlantType } from "./PlantType";

export default interface Plant {
  Id: number;
  Gsdb: string;
  Name: string;
  TwoDigitCode: string;
  City: string;
  Street: string;
  ZipCode: string;
  PlantDetails: string;
  PartDestination: PlantType;
  EdcId: number | null;
  CountryId: number | null;
  CountryIsoCode: string | null;
  ZipArea: string;
  Region: string | null;

  // GeoCoordinates
  Latitude?: string;
  Longitude?: string;
  MapAndGuideLatitude: number | null;
  MapAndGuideLongitude: number | null;
}

export const isExistingPlant = (plant: Plant) => plant.Id > 0;
